import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import { goToPage, stepParams, checkCanUpgradeCellularProgram } from '../../DisconnectServiceSlice'
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import images from '../../DisconnectPhotos/images'
import './DisconnectCellularPage'
import Config from '../../../../../Config'
import { isBrowser } from "react-device-detect";
import gaParams from '../../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../../utilities/analytics/tracking';
import { Container, Row } from 'reactstrap';
import useExtendedEffect from '../../../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../../../utilities/hooks/useClearStateResetFlag';



function DisconnectCellularPage(props) {
    
    const picOfProgram = props.upgradedPackage;
    const picOfKosherProgram = props.upgradedKosherPackage;
    const pdfTerms = Config.epiBaseUrl + props.pdf;
    const upgradeCellularCode = props.code;
    const kosherCode = props.kosherCode;
    const showProgram = props.showCellularPackage;
    const showKosherProgram = props.kosherShowPackage;

    useEffect(() => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo(0, 0);
        } 
        gaEvent(gaParams.DISCONNECT_ENTER_DISCONNECT_CELLULAR_PAGE.category, gaParams.DISCONNECT_ENTER_DISCONNECT_CELLULAR_PAGE.eventType, gaParams.DISCONNECT_ENTER_DISCONNECT_CELLULAR_PAGE.eventParams);
      }, [])

    // useEffect(() => {
    //     if(props.canUpgradeCellular != null) {
    //         if(props.canUpgradeCellular === true) {
    //              props.goToPage({ page: 'SUCCESS_UPDATE_CELLULAR_PROGRAM', params: { ...props.stepParams, hideHeader: true } })
    //         }
    //         else if(props.canUpgradeCellular === false) {
    //             props.goToPage({ page: 'GET_BACK_TO_YOU_BY_NUMBER', params: { ...props.stepParams, hideHeader: true } })
    //         } 
    //     }
    // },[props.canUpgradeCellular])

    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            if(props.canUpgradeCellular != null) {
                if(props.canUpgradeCellular === true) {
                     props.goToPage({ page: 'SUCCESS_UPDATE_CELLULAR_PROGRAM', params: { ...props.stepParams, hideHeader: true } })
                }
                else if(props.canUpgradeCellular === false) {
                    props.goToPage({ page: 'GET_BACK_TO_YOU_BY_NUMBER', params: { ...props.stepParams, hideHeader: true } })
                } 
            }
        }
    }, [props.canUpgradeCellular]);


    async function updatePackage(productId, upgradeCellularCode) {
        const data = { productId, upgradeCellularCode };
        reportClickOnUpgrade();
        await props.checkCanUpgradeCellularProgram(data);
    }

    function reportClickOnUpgrade() {
         gaEvent(gaParams.DISCONNECT_CLICK_ON_UPGRADE_CELLULAR_PACKAGE.category, gaParams.DISCONNECT_CLICK_ON_UPGRADE_CELLULAR_PACKAGE.eventType, gaParams.DISCONNECT_CLICK_ON_UPGRADE_CELLULAR_PACKAGE.eventParams);
    }
 
    function reportGAOpenPdf() {
        gaEvent(gaParams.DISCONNECT_CLICK_ON_VIEW_PDF_PROGRAM_CELLULAR.category, gaParams.DISCONNECT_CLICK_ON_VIEW_PDF_PROGRAM_CELLULAR.eventType, gaParams.DISCONNECT_CLICK_ON_VIEW_PDF_PROGRAM_CELLULAR.eventParams);
    }

    function redirectAndReportGA() {
        gaEvent(gaParams.DISCONNECT_CLICK_ON_CONTINUE_DISCONNECT_CELLULAR_PAGE.category, gaParams.DISCONNECT_CLICK_ON_CONTINUE_DISCONNECT_CELLULAR_PAGE.eventType, gaParams.DISCONNECT_CLICK_ON_CONTINUE_DISCONNECT_CELLULAR_PAGE.eventParams)
        props.goToPage({ page: 'SCHEDULE_DISCONNECT_DATE_PAGE', params: { ...stepParams, hideHeader: false } })
    }

    return (
        <Container className="DisconnectCellularPage-root">
            <Row className="main-header-row">
                <h3 className="main-header">חשוב לדעת</h3>
            </Row>
            {props.serviceToDisconnect.HasBanlvlPpUnlimited ? 
               <Row className="paragraph-txt-row" style={{marginBottom: '-10px'}}><div className="paragraph-txt" style={{marginBottom: '-10px'}}>מנוי זה משויך לחבילה שבה המחיר תלוי בכמות המנויים.<br/> ניתוק המנוי עשוי להשפיע על המחיר של המנויים הנוספים בחבילה</div></Row>:
                null            
            }
            <Row className="paragraph-txt-row">
                <div className="paragraph-txt">
                עם הניתוק הקו יבוטל ואי אפשר יהיה לנייד אותו לאחר מכן.
                <br /> 
                הניתוק יתבצע במועד לבחירתך.  כשיגיע היום, נשלח סמס ולאחריו מיד ננתק את הקו.
                <br />
                החיוב בחשבונית הקרובה יהיה הסכום היחסי עד למועד הניתוק.
                </div>
            </Row>
            <Row className="stand-alone-commercial-row">
                {isBrowser ? <Image alt="some-commercial" src={images.bodyPicPurpleMid} /> : <Image alt="some-commercial" src={images.bodyPicPurpleSmall} />}
            </Row>
            {props.serviceToDisconnect.modemInd == true || props.serviceToDisconnect.subStatus == 'S' || showKosherProgram == false || showProgram == false ? null : <Row className="full-commercial-row">
                <h3 className="secondary-main-header">אבל רגע לפני...</h3>
                <div className="bottom-paragraph-txt">נשמח להציע לך חבילת סלולר שאולי תשאיר אותך אתנו</div>
                <div className="some-commercial">
                    {!props.serviceToDisconnect.isKosher ? <Image className="commercial-background" alt="some-commercial" src={Config.epiBaseUrl + picOfProgram} /> : <Image className="commercial-background" alt="kosher-commercial" src={Config.epiBaseUrl + picOfKosherProgram} />}
                    <a className="linkToPdf" href={pdfTerms} target="_blank" onClick={() => reportGAOpenPdf()}>תקנון החבילה</a>
                    {!props.serviceToDisconnect.isKosher ? <div className="myWhiteBtn" onClick={() => updatePackage(props.serviceToDisconnect.productId, upgradeCellularCode)}>להחלפת חבילה</div> : <div className="myWhiteBtn" onClick={() => updatePackage(props.serviceToDisconnect.productId, kosherCode)}>מעוניין בחבילה</div>}
                </div>
            </Row>}
            <div className="btn-proceed">
                <BtnSubmit text="המשך לניתוק" onclick={() => redirectAndReportGA()}/>    
            </div>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    stepInProcess: state.disconnectServicesBlock.stepInProcess,
    stepParams: state.disconnectServicesBlock.stepParams,
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
    canUpgradeCellular: state.disconnectServicesBlock.canUpgradeCellular
});
  
const mapDispatchToProps = {
    goToPage,
    checkCanUpgradeCellularProgram
};

export default connect(mapStateToProps, mapDispatchToProps)(DisconnectCellularPage);